<template lang="pug">
  v-radio-group(v-model="selectedReward")
    v-row(no-gutters)
      v-col.mb-4(cols="12" v-for="reward in rewards" :key="reward.id")
        template(v-if="reward.disabled")
          v-card.round-lg.pa-4(outlined disabled)
            reward-to-redeem-item(:reward="reward" :loyaltySystem="loyaltySystem" disabled)
        template(v-else)
          v-card.round-lg.pa-4(outlined :class="[{ 'border-selected': isSelected(reward) }]" @click="handleSelectedReward(reward)")
            reward-to-redeem-item(:reward="reward" :loyaltySystem="loyaltySystem")
</template>

<script>
import RewardToRedeemItem from "@/components/clinic/checkout/marketing/redeem/reward/RewardToRedeemItem.vue";
import {mapGetters} from "vuex";

export default {
  components: {
    RewardToRedeemItem
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    loyaltySystem: {
      type: String,
      required: true
    },
    availableRewards: {
      type: Array,
      default: () => ([])
    },
    collectedValue: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      selectedReward: null
    }
  },
  computed: {
    ...mapGetters({
      loyaltySettings: 'marketing/getLoyaltySettings'
    }),
    rewards() {
      return this.loyaltySettings?.rewards?.map((reward, index) => this.sanitizeData(reward, index))
    },
    rewardsPosition() {
      return this.loyaltySettings?.rewards?.map(reward => reward.tier_value) || []
    },
  },
  methods: {
    isSelected(reward) {
      return this.selectedReward?.id === reward.id
    },
    handleSelectedReward(reward) {
      this.selectedReward = reward
      this.$emit('input', reward)
    },
    sanitizeData(reward, index) {
      const newObj = {
        ...reward
      }
      const disabled = !this.availableRewards.includes(reward.id)
      newObj.disabled = disabled
      newObj.eligibility = this.getEligibilityText(disabled, reward, index)
      return newObj
    },
    getEligibilityText(disabled, reward, index) {
      if (this.loyaltySystem === 'points') return `-${reward.tier_value} pts`

      if (!disabled) return 'Eligible'
      const eligibilityCount = this.getEligibilityCount(reward, index)
      if (eligibilityCount <= 0) return 'Redeemed'
      return `${eligibilityCount} more needed`
    },
    getEligibilityCount(reward, index) {
      return this.rewardsPosition[index] - this.collectedValue
    }
  },
}
</script>

<style scoped>
.border-selected {
  border: 2px solid #333333 !important;
}
</style>